// When the board takes its phone layout: a window under 720 wide, or a phone turned on its side (short, and worked
// by touch). A desktop window keeps its layout at any height: its pointer is a mouse or a trackpad, never coarse.

export function phoneSized(): boolean {
  if (typeof window === "undefined") return false;
  return window.innerWidth < 720 || (window.innerHeight < 500 && !!window.matchMedia?.("(pointer: coarse)").matches);
}
